export default __webpack_public_path__ + "c879a942af0609ed258df111f1ffdca6.png";